import { BillingInfo, BillingStatus } from 'models/Billing';

const HOMEPAGE_CTA_STATUSES: BillingStatus[] = [
  'unconverted',
  'canceled',
  'past_due'
];

export const isProviderBilling = (billing: BillingInfo): boolean => {
  return (
    billing.billing_mode === 'manual' ||
    billing.billing_mode === 'exempt' ||
    billing.billing_status === 'manual_active'
  );
};

export const isHomepageTrialCtaEligible = (billing: BillingInfo): boolean => {
  return (
    billing.billing_mode === 'self_service' &&
    HOMEPAGE_CTA_STATUSES.includes(billing.billing_status)
  );
};

export const isTrialOrActive = (billing: BillingInfo): boolean => {
  return (
    billing.billing_status === 'trialing' || billing.billing_status === 'active'
  );
};

export const formatPlanName = (planCode?: string | null): string => {
  if (!planCode) {
    return 'Shiplab';
  }
  return planCode
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
};

export const formatBillingDate = (value?: string | null): string => {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
